import React from 'react'
import CurrencySign from '../../../../components/shared/CurrencySign';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';

import Cell from '../Cell';
import classes from './RowContent.module.scss';

const typeNames = {
  working_days: 'Days worked',
  total_hours: 'Total Hours',
  worked_hours: 'Regular Hours',
  working_time: 'Working Time',
  break_hours: 'Break Hours',
  night_hours: 'Night Work Hours',
  holiday_hours: 'Bank Holiday Hours',
  overtime_hours: 'Overtime Hours',
  show_costs: 'Cost',
  additional_bonus: 'Bonus',
};

const timeConvert = (num) => {
  const hours = (num / 60);
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  return rhours+":"+String(rminutes).padStart(2, '0');
}

const getTotalTime = (sheet) => {
  const totalHoursInSeconds = sheet.reduce((acc, item) => {
    const start = item.start ? moment(item.start, 'YYYY-MM-DD HH:mm:ss') : null
    const end = item.end ? moment(item.end, 'YYYY-MM-DD HH:mm:ss') : null
    if (start && end) {
      const duration = moment.duration(end.diff(start))
      return acc + duration.asSeconds()
    }
    return acc
  }, 0)
  const duration = moment.duration(totalHoursInSeconds, 'seconds')
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  const totalTime = `${hours}:${String(minutes).padStart(2, '0')}`
  return totalTime
}

const getCommentTooltip = (item, comment) => {
  return `
    Original<br />
    From: <b>${item.original_row.start ? moment(item.original_row.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : 'N/A'}</b> To: <b>${item.original_row.end ? moment(item.original_row.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : 'N/A'}</b><br/>
    Changed<br/>
    From: <b>${item.start ? moment(item.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : 'N/A'}</b> To: <b>${item.end ? moment(item.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : 'N/A'}</b><br/>
    Comment: ${comment}
  `
}

const getChangedData = (found, field) => {
  if (found.change.change_flags.day_removed) {
    return (
      <div style={{color: 'red'}}>
        { found.original_row[field] ? timeConvert(found.original_row[field]) : '' }
      </div>
    )
  }

  if (found.change.change_flags.hours_changed && (field === 'worked_hours' || field === 'total_hours')) {
    if (found[field]) {
      return (
        <div style={{color: 'orange'}}>
          { found[field] ? timeConvert(found[field]) : '' }
        </div>
      )
    }
    return (
      <div style={{color: 'red'}}>
        { found.original_row[field] ? timeConvert(found.original_row[field]) : '' }
      </div>
    )
  }
  
  if (
    found.change.change_flags.overtime_changed && field === 'overtime_hours' ||
    found.change.change_flags.break_changed && field === 'break_hours' ||
    found.change.change_flags.holiday_changed && field === 'holiday_hours' ||
    found.change.change_flags.night_changed && field === 'night_hours'
  ) {
    if (found[field]) {
      return (
        <div style={{color: 'orange'}}>
        { timeConvert(found[field]) }
      </div>
      )
    }
    return (
      <div style={{color: 'red'}}>
        { found.original_row[field] ? timeConvert(found.original_row[field]) : '' }
      </div>
    )
  }
  return found[field] ? timeConvert(found[field]) : '';
}

const RowContent = ({
  sheet,
  field,
  resource,
  employeesWithOvertime,
  daysOfMonth,
  pastDay,
  requestBehalves,
  mergeTimesheetPlaces,
}) => {
  const { t } = useTranslation();

  const foundItem = (day) => {
    const found = sheet.find((item) => resource.id === item.employeeId && item.day*1 === day*1 && (resource.place_id === item.place_id || item.original_row)); // TODO: need to check if place_id is needed here or if original_row check is enough
    if (found?.change) {
      switch (field) {
        case 'working_days':
          return found[field]
        case 'worked_hours':
        case 'total_hours':
        case 'break_hours':
        case 'night_hours':
        case 'holiday_hours':
        case 'overtime_hours':
          return getChangedData(found, field);
        default:
          return ''
      }
    }
    if (found && found[field]) {
      // if (field === 'worked_hours') {
      //   return timeConvert(Math.max(0, found[field] - found['night_hours']))
      // }
      if (field === 'show_costs') {
        return (
          <div>
            <CurrencySign />{numeral(found[field]).format('0.00')}
          </div>
        )
      } else if (field === 'additional_bonus') {
        return <><CurrencySign />{numeral(found[field]).format('0.00')}</>;
      } else if (field === 'worked_hours') {
        return timeConvert(found[field])
      } else {
        return field !== 'working_days' ? timeConvert(found[field]) : found[field];
      }
    }

    return '';
  }

  const foundTime = (day) => {
    const found = sheet.find((item) => resource.id === item.employeeId && item.day*1 === day*1 && (resource.place_id === item.place_id || item.original_row));
    if (found && found[field]) {
      return found[field]*1;
    }

    return 0;
  }

  const foundCost = (day) => {
    const found = sheet.find((item) => resource.id === item.employeeId && item.day*1 === day*1 && resource.place_id === item.place_id);
    if (found && found[field+'_cost']) {
      return found[field+'_cost']*1;
    } else if (found && found[field] && field === 'show_costs') {
      return found[field]*1;
    }

    return 0;
  }

  

  let time = 0;
  let cost = 0;

  const check = (item) => {
    if (item.statistic && item.id === "totalTime" && field !== 'show_costs' && field !== 'additional_bonus') {
      return time > 0 ? (field !== 'working_days' ? timeConvert(time) : time) : '';
    }
    if (item.statistic && item.id === "totalCost") {
      return cost > 0 ? <><CurrencySign />{numeral(cost).format('0.00')}</> : '';
    }

    if (item.statistic && item.id === 'totalBonus' && field === 'additional_bonus') {
      const bonus = sheet.reduce((acc, s) => {
        if (s.employeeId === resource.id && s.place_id === resource.place_id && s.additional_bonus) {
          return acc + parseFloat(s.additional_bonus);
        }
        return acc;
      }, 0)
      return bonus > 0 ? <><CurrencySign />{numeral(bonus).format('0.00')}</> : ''
    }

    if (item.statistic && item.id === "plannedTime" && field === 'total_hours'){
      const found = sheet.find((item) => resource.id === item.employeeId && resource.place_id === item.place_id);
      if (found && found.planned_time) {
        return found.planned_time;
      }
    }

    if (item.statistic && item.id === "targetTime" && field === 'total_hours'){
      const found = sheet.find((item) => resource.id === item.employeeId && resource.place_id === item.place_id);
      if (found && found.target_time) {
        return found.target_time;
      }
    }

    if (item.statistic && item.id === "plannedTimeMonth" && field === 'total_hours'){
      const found = sheet.find((item) => resource.id === item.employeeId && resource.place_id === item.place_id);
      if (found && found.planned_time_month) {
        return found.planned_time_month;
      }
    }

    if (item.statistic && item.id === "targetTimeMonth" && field === 'total_hours'){
      const found = sheet.find((item) => resource.id === item.employeeId && resource.place_id === item.place_id);
      if (found && found.target_time_month) {
        return found.target_time_month;
      }
    }

    return ''
  }

  const parsedTitle = (item) => {
    return item.statistic ? check(item) : foundItem(item.title)
  }

  const tooltipInner = (itemCheck, field) => {
    if (!itemCheck.statistic && field === 'total_hours') {
      const find = sheet.find((item) => resource.id === item.employeeId && item.day*1 === itemCheck.id*1 && (resource.place_id === item.place_id || item.original_row)); //  && resource.place_id === item.place_id
      if (find) {
        return "From <strong>" + moment(find.start).format('HH:mm') + "</strong> To <strong>" + moment(find.end).format('HH:mm') + "</strong>";
      }

      return find && find[field] ? timeConvert(find[field]) : '';
    }

    if (!itemCheck.statistic && field === 'show_costs') {
      const find = sheet.find((item) => resource.id === item.employeeId && item.day*1 === itemCheck.id*1 && resource.place_id === item.place_id);
      if (find?.additional_bonus) {
        const pureCost = find.show_costs - find.additional_bonus
        return `<strong>${pureCost ? `${numeral(pureCost).format('0.00')} + ` : ''}${numeral(find.additional_bonus).format('0.00')} (bonus)</strong>`;
      }
    }

    if (itemCheck.statistic && field === 'show_costs') {
      const totals = sheet.filter((item) => resource.id === item.employeeId && resource.place_id === item.place_id).reduce((acc, item) => {
        return {
          bonus: acc.bonus + (item.additional_bonus ? parseFloat(item.additional_bonus) : 0),
          cost: acc.cost + (item.cost ? parseFloat(item.cost) : 0)
        }
      }, {bonus: 0, cost: 0})

      if (totals.bonus) {
        const pureCost = totals.cost - totals.bonus
        return `<strong>${pureCost ? `${numeral(pureCost).format('0.00')} + ` : ''}${numeral(totals.bonus).format('0.00')} (bonus)</strong>`;
      }
    }

    return '';
  }

  const requestBehalve = (item) => {
    
    const requestBehalve = requestBehalves.find(requestBehalve => requestBehalve.mark_in_schedule_and_time_sheet
      && requestBehalve.employee_id*1 === resource.id*1
      && moment(item.date).isSameOrAfter(moment(requestBehalve.from, 'YYYY-MM-DD'))
      && moment(item.date).isSameOrBefore(moment(requestBehalve.to, 'YYYY-MM-DD'))
      && !requestBehalve.non_working_days.includes(moment(requestBehalve.from, 'YYYY-MM-DD').set('date', item.id).format('YYYY-MM-DD'))
    );
    return requestBehalve;
    
  };
  
  return (
    <>
      <div className={classes.rowContent}>
        <Cell
          key={0}
          title={t(typeNames[field])}
          article={true}
        />
        {
          daysOfMonth.map((item, index, array) => {
            if(index < item.id ){
              time+=foundTime(item.title)
              cost+=foundCost(item.title)
            }
            const firstStaticticIndex = array.findIndex(el => el.statistic)
            
            const eventItem = sheet.find((s) => resource.id === s.employeeId && s.day*1 === item.id && (resource.place_id === s.place_id || s.original_row)) // TODO: need to check if place_id is needed here or if original_row check is enough 
            const commentTooltip = field === 'total_hours' && eventItem?.change?.comment && getCommentTooltip(eventItem, eventItem.change.comment)
            // if (field === 'total_hours' && item.id == '23') {
              // console.log(eventItem)
              // console.log(commentTooltip)
              // console.log(parsedTitle(item))
            // }

            const title = item.id === 'totalTime' && field === 'total_hours' && item.statistic ? getTotalTime(sheet.filter(s => s.employeeId === resource.id && resource.place_id === s.place_id)) : parsedTitle(item)
            // console.log('resource', resource)
            const placeId = mergeTimesheetPlaces ? 0 : resource.place_id;
            return (
             <Cell
                key={item.id}
                cellId={item.id}
                title={title}
                statistic={item.statistic}
                weekend={item.weekend}
                isOvertime={field === 'total_hours' && employeesWithOvertime[`${resource.employeeId}_${placeId}`]?.[item.id]?.isOvertime}
                tooltip={commentTooltip ? commentTooltip : tooltipInner(item, field)}
                past={!item.statistic && pastDay >= item.id}
                holiday={item.holiday}
                withBorder={index === firstStaticticIndex}
                requestBehalve={!item.statistic && field === 'working_days' ? requestBehalve(item) : null}
            />)
            }
          )
        }
      </div>
    </>
  );
};

export default RowContent
